import { useTracking } from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';
import { CompetitorWrapper } from './styled';
import loadable from '@loadable/component';

const Snowflake = loadable(
  () => import('@/components/DeprecatedSnowflake/Snowflake'),
  {
    fallback: (
      <div className="relative w-full min-w-x6">
        <div className="bones relative w-full rounded-full pb-[100%]" />
      </div>
    ),
  }
);

export interface CompetitorProps {
  points: number[];
  index: number;
  companyId: string;
  uniqueSymbol: string;
  companyName: string;
  companyUrl: string;
  marketCap: string;
}
export default function Competitor({
  index,
  points,
  companyId,
  companyName,
  uniqueSymbol,
  marketCap,
  companyUrl,
}: CompetitorProps) {
  const { trackEvent } = useTracking();

  return (
    <CompetitorWrapper data-cy-id={`competitor-${index}`}>
      <RouterLink
        inheritColor
        noUnderline
        to={companyUrl}
        onClick={() => {
          trackEvent({
            action: 'click',
            modifier: 'grid',
            index,
            uniqueSymbol,
            companyId,
          });
        }}
      >
        <div className="p-4">
          <Snowflake points={points} />
          <div className="flex flex-col gap-y-1.5 pt-2">
            <h3 className="m-0 truncate text-sm">{companyName}</h3>
            <div className="text-xs">
              <div className="uppercase">
                <span className="sr-only">Symbol: </span>
                <span>{uniqueSymbol}</span>
              </div>
              <div className="truncate opacity-50">
                <span className="sr-only">Market cap: </span>
                <span>{marketCap}</span>
              </div>
            </div>
          </div>
        </div>
      </RouterLink>
    </CompetitorWrapper>
  );
}
